module.exports = __webpack_public_path__ + "img/back_3.125bebc9.png";